module.exports = __webpack_public_path__ + "static/media/audio.63b221a4.svg";